import { useEffect } from "react";

export const useFilterProviderSyncEffects = ({
  updateState,
  contextFilter,
  courses,
  programs,
  filteredCourses,
  filteredPrograms,
  searching,
}) => {
  useEffect(() => {
    updateState({
      totalCount: (courses?.length ?? 0) + (programs?.length ?? 0),
    });
  }, [courses, programs, updateState]);

  useEffect(() => {
    updateState((prevState) => ({
      filter: {
        ...prevState.filter,
        ...contextFilter,
      },
    }));
  }, [contextFilter, updateState]);

  useEffect(() => {
    if (!searching) {
      updateState({
        hitCount:
          (filteredCourses.active?.length ?? 0) +
          (filteredPrograms.active?.length ?? 0),
      });
    }
  }, [filteredCourses, filteredPrograms, searching, updateState]);
};
